import styles from './ExternalMedia.scss';

import debounce from 'lodash/debounce';
import React from 'react';
import YouTube from 'react-youtube';

import { withBrowser } from '../Responsive/WithBrowser';
import { getPlayerHeight, getPlayerWidth } from './utils';

export interface ExternalMediaProps extends React.AllHTMLAttributes<HTMLElement> {
  youtubeId?: string;
  isMobile?: boolean;
  isTablet?: boolean;
  disableAutoPlay?: boolean;
  onEnd?: () => void;
}

class ExternalMedia extends React.Component<ExternalMediaProps> {
  onResize = debounce(() => {
    this.forceUpdate();
  });

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const { youtubeId, isMobile, isTablet, disableAutoPlay, onEnd = () => history.back() } = this.props;

    const viewportWidth = (window.innerWidth);
    const playerWidth = getPlayerWidth(viewportWidth, isMobile, isTablet);
    const playerHeight = getPlayerHeight(playerWidth);

    const opts = {
      width: `${playerWidth.toString()}px`,
      height: `${playerHeight.toString()}px`,
      playerVars: {
        autoplay: disableAutoPlay ? 0 : 1 as 0 | 1,
        host: 'https://www.youtube-nocookie.com',
        rel: 0 as 0,
      },
    };

    return (
      <YouTube
        containerClassName={styles.youtubeContainer}
        videoId={youtubeId}
        onEnd={onEnd}
        opts={opts}
      />
    );
  }
}

const Browsered = withBrowser(browser => ({
  isMobile: browser.is.mobile,
  isTablet: browser.is.tablet,
}))(ExternalMedia);
type Browsered = typeof Browsered;

export {
  Browsered as ExternalMedia,
  ExternalMedia as _ExternalMedia,
};
